<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal({recargar: true});">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title v-text="'NUEVO EVENTO'"></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="container-fluid my-4">
      <div  class="row">
        <div class="col-12 text-secondary">
          EMPRESA
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." @ionChange="listarSucursales();" v-model="evento.empresa">
              <ion-select-option :key ="index" v-for="(empresa, index) in empresas" :value="empresa" v-text="empresa.emp_nombre"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="sucursales.length > 0" class="row mt-3">
        <div class="col-12 text-secondary">
          SUCURSAL
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." @ionChange="listarPersonalSucursal(); listarTiposEventoEmpresa();" v-model="evento.sucursal">
              <ion-select-option :key ="index" v-for="(sucursal, index) in sucursales" :value="sucursal" v-text="sucursal.suc_nombre"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="personal.length > 0" class="row mt-3">
        <div class="col-xl-9 col-md-6 col-6 text-secondary">
          REPORTADO POR
        </div>
        <div class="col-xl-3 col-md-6 col-6 text-primary text-right">
          <ion-button v-if="evento.persona" @click="evento.persona='';" color="primary" size="small" shape="round">Cambiar <fa :icon="['fad', 'edit']" class="fa-fw ml-2"></fa></ion-button>
        </div>
        <div v-if="evento.persona" class="col-12">
          <ion-item>{{evento.persona.usr_nombres+' '+evento.persona.usr_apellido_p+' '+evento.persona.usr_apellido_m}}</ion-item>
        </div>
        <div v-else class="col-12 mt-2">
          <ion-searchbar placeholder="Buscar" animated="true" debounce="50" v-model="filtroBusqueda" @ionChange="filtrarPersonal()"></ion-searchbar>
          <ion-list lines="full" style="max-height: 200px; overflow-y: scroll;">
            <ion-item @click="evento.persona=persona;" button v-for="(persona,index) in personalFiltrado" :key="'usr'+index">{{persona.usr_nombres+' '+persona.usr_apellido_p}}</ion-item>
          </ion-list>
        </div>
      </div>

      <div v-if="tiposEvento.length > 0" class="row mt-3">
        <div class="col-12 text-secondary">
          ORIGEN DE LA FALLA
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." @ionChange="listarSubTiposEvento(tipoEvento, 1);" v-model="tipoEvento">
              <ion-select-option :key ="index" v-for="(tipo, index) in tiposEvento" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="subTiposEvento1.length > 0" class="row mt-3">
        <div class="col-12 text-secondary">
          SUBATEGORÍA 1
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="SELECCIONE.." @ionChange="listarSubTiposEvento(subTipoEvento1, 2);" v-model="subTipoEvento1">
              <ion-select-option :key ="index" v-for="(tipo, index) in subTiposEvento1" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="subTiposEvento2.length > 0" class="row mt-3">
        <div class="col-12 text-secondary">
          SUBCATEGORÍA 2
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="SELECCIONE.." @ionChange="evento.tipo=subTipoEvento2" v-model="subTipoEvento2">
              <ion-select-option :key ="index" v-for="(tipo, index) in subTiposEvento2" :value="tipo" v-text="tipo.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="evento.tipo != ''" class="row mt-3">
        <div class="col-12 text-secondary">
          DESCRIPCIÓN DEL EVENTO
        </div>
        <div class="col-12">
          <ion-textarea rows="5" cols="20" class="text-uppercase" v-model="evento.descripcion" placeholder="ESCRIBA ACÁ..."></ion-textarea>
        </div>
      </div>

      <div v-if="evento.tipo != ''" class="row mt-2">
        <div class="col-12 d-flex align-items-center">
          <ion-toggle class="pl-0" v-model="incluyeImagenes" @ionChange="imagenes=[];" color="secondary"></ion-toggle> 
          <span class="text-secondary">INCLUIR IMÁGENES</span>
          <span v-if="incluyeImagenes" class=" ml-3 text-success">SÍ</span>
          <span v-else class="ml-3 text-danger">NO</span>
        </div>
      </div>

      <div v-if="incluyeImagenes" class="row mt-2 justify-content-center">
        <div class="col-6 text-center px-1">
          <ion-button @click="subirImagen()" color="primary" shape="round" fill="outline"><fa icon="image-polaroid" type="fad" class="fa-fw mr-1"></fa>SUBIR FOTO</ion-button>
        </div>
        <div v-if="esMovil" class="col-6 text-center px-0">
          <ion-button @click="tomarImagen()" color="primary" shape="round" fill="outline"><fa icon="camera" type="fad" class="fa-fw mr-1"></fa>TOMAR FOTO</ion-button>
        </div>
        <div class="col-12 text-center">
          <!-- ACA IRIAN LAS FOTOS -->
          <div v-if="imagenes.length>0" class="row mb-2 justify-content-center">
            <div class="col-3 mx-1 mt-2 pb-3 shadow-sm" :id="'foto'+index" :key="foto" v-for="(foto, index) in imagenes">
              <div class="cursor-pointer" @click.stop.prevent="eliminaFoto('foto'+index, index);">
                <fa icon="times-square" type="fas" class="my-2 float-left text-danger"></fa>
              </div>
              <img :src="foto.webviewPath">
            </div>
          </div>
        </div>
      </div>

      <div v-if="evento.tipo != ''" class="row mt-3">
        <div class="col-12 text-secondary">
          ANALISIS DE LA CAUSA
        </div>
        <div class="col-12">
          <ion-textarea rows="5" cols="20" class="text-uppercase" v-model="evento.causa" placeholder="ESCRIBA ACÁ..."></ion-textarea>
        </div>
      </div>

      <div v-if="evento.tipo != ''" class="row mt-3">
        <div class="col-12 text-secondary">
          ACCIONES CORRECTIVAS
        </div>
        <div class="col-12">
          <ion-textarea rows="5" cols="20" class="text-uppercase" v-model="evento.solucion" placeholder="ESCRIBA ACÁ..."></ion-textarea>
        </div>
      </div>

      <div v-if="evento.tipo != ''" class="row mt-2">
          <div class="col-12">
            TIEMPO ESTIMADO:
          </div>
          <div class="col-12">
            <ion-list>
              <ion-radio-group :value="tipoTiempo" v-model="tipoTiempo">
                <ion-list-header>
                  <ion-label>HORAS / MINUTOS</ion-label>
                </ion-list-header>

                <ion-item>
                  <ion-label>HORAS</ion-label>
                  <ion-radio slot="start" value="HORAS" ></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label>MINUTOS</ion-label>
                  <ion-radio slot="start" value="MINUTOS" ></ion-radio>
                </ion-item>
                
              </ion-radio-group>
              <ion-item>
                <ion-input v-model="tiempoEstimado" placeholder="Ingresa tiempo" color="dark" type="number"></ion-input>
                <ion-label>{{tipoTiempo}}</ion-label>
              </ion-item>
            </ion-list>
          </div>
        </div>

    </div>

  </ion-content>

  <ion-footer>
    <div class="row mx-2 mb-1 mt-1">
      <div class="col-6">
        <ion-button color="danger" @click="cerrarModal()" expand="block" shape="round">CERRAR</ion-button>
      </div>
      <div class="col-6">
        <ion-button @click="registrarEvento();" color="success" expand="block" shape="round"
        :disabled="
          evento.tipo        == '' || 
          evento.descripcion == '' || 
          evento.causa       == '' || 
          evento.solucion    == '' || 
          tiempoEstimado     == '' ||
          (incluyeImagenes && imagenes.length == 0)" 
        >REGISTRAR</ion-button>
      </div>
    </div>
  </ion-footer>
</template>

<script>
import { modalController, toastController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonSelect, IonSelectOption, IonItem, IonTextarea, IonToggle, IonLabel, /* IonCard, IonCardContent, */ IonInput, alertController, loadingController, IonList, IonListHeader, IonRadio, IonRadioGroup, IonSearchbar} from '@ionic/vue';
import { defineComponent      } from 'vue';
import { addIcons             } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline} from 'ionicons/icons';
import { Preferences          } from '@capacitor/preferences';
import { cerrarSesion         } from '@/plugins/funciones.ts';
import { tomarFoto, subirFoto } from '@/plugins/usarCamara';
import * as $                   from "jquery";
import axios                    from 'axios';
import rutaBase                 from '@/plugins/variables';

export default defineComponent({
  name: 'ModalNuevoEvento',
  props: {
    esMovil : Boolean
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonSelect, IonSelectOption, IonItem, IonTextarea, IonToggle, IonLabel, /* IonCard, IonCardContent, */ IonInput, IonList, IonListHeader, IonRadio, IonRadioGroup, IonSearchbar},
  data(){
    return {
      cargando            : false,
      empresas            : [],
      sucursales          : [],
      personal            : [],
      personalFiltrado    : [],

      tiposEvento         : [],
      subTiposEvento1     : [],
      subTiposEvento2     : [],
      tipoEvento          : '',
      subTipoEvento1      : '',
      subTipoEvento2      : '',
      evento              : {empresa:'', sucursal:'', persona:'', tipo:'', tiempoEstimado:'', descripcion:'', causa:'', solucion:'', fotos:[]},
      incluyeImagenes     : false,
      imagenes            : [],
      idImagenBorrar      : '',
      indiceImagenBorrar  : '',
      tipoTiempo          : 'MINUTOS',
      tiempoEstimado      : '',
      filtroBusqueda      : ''
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  mounted(){
    this.datosUsuario();
    this.listarEmpresas();
  },
  methods:{
    async datosUsuario(){
      this.rutUsuario  = (await Preferences.get({ key: 'rut' })).value;
      this.tipoUsuario = (await Preferences.get({ key: 'tipo_usuario' })).value;
    },

    async listarEmpresas(){
      const modalCarga  = await this.modalCargando();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };

      axios.post(rutaBase+'/soporte/listarEmpresas', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.empresas = resp.data;
          modalCarga.dismiss();
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR EMPRESAS");
        modalCarga.dismiss();
      });
    },

    async listarSucursales(){
      this.tipoEvento = this.subTipoEvento1 = this.subTipoEvento2 = this.evento.sucursal = this.evento.tipo = this.evento.persona = '';
      this.tiposEvento      = [];
      this.subTiposEvento1  = [];
      this.subTiposEvento2  = [];
      this.personal         = [];
      this.personalFiltrado = [];
      const modalCarga      = await this.modalCargando();
      const token           = await Preferences.get({ key: 'token_auth' });
      const headers         = { headers: { 'Authorization': `${token.value}` } };
      const data            = new URLSearchParams();
      data.append('id_empresa', this.evento.empresa.emp_id);
      axios.post(rutaBase+'/soporte/listarSucursalesEmpresa', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          if(resp.data.length == 1){
            this.evento.sucursal = resp.data[0];
            this.listarPersonalSucursal();
            this.listarTiposEventoEmpresa();
          }
          this.sucursales = resp.data;
          modalCarga.dismiss();
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR SUCURSALES");
        modalCarga.dismiss();
      });
    },

    async listarPersonalSucursal(){
      if(this.evento.empresa == '' || this.evento.sucursal == ''){
        return;
      }
      const modalCarga     = await this.modalCargando();
      const token          = await Preferences.get({ key: 'token_auth' });
      const headers        = { headers: { 'Authorization': `${token.value}` } };
      const data           = new URLSearchParams();
      data.append('id_empresa', this.evento.empresa.emp_id);
      data.append('id_sucursal', this.evento.sucursal.suc_id);
      axios.post(rutaBase+'/soporte/listarPersonalSucursal', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.personal = resp.data;
          this.personalFiltrado = resp.data;
          modalCarga.dismiss();
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR PERSONAL");
        modalCarga.dismiss();
      });
    },

    filtroPersonal(filtro){
      const filtros = filtro.split(' ');
      return this.personal.filter((item) => {
        for(let i=0; i < filtros.length; i++) {
          if(item.usr_correo){
            return  item.usr_rut.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_nombres.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_apellido_p.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 ||
                  item.usr_apellido_m.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 ||
                  item.usr_correo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1;
          }
          else {
            return  item.usr_rut.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_nombres.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 || 
                  item.usr_apellido_p.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1 ||
                  item.usr_apellido_m.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(filtros[i].toLowerCase()) > -1;
          }
        }
      });
    },

    filtrarPersonal(){
      if(this.filtroBusqueda == ''){
        this.personalFiltrado = this.personal;
      }
      else {
        this.personalFiltrado = this.filtroPersonal(this.filtroBusqueda);
      }
    },

    async listarTiposEventoEmpresa(){
      this.tipoEvento = this.subTipoEvento1 = this.subTipoEvento2 = this.evento.tipo = '';
      this.tiposEvento     = [];
      this.subTiposEvento1 = [];
      this.subTiposEvento2 = [];
      const modalCarga     = await this.modalCargando();
      const token          = await Preferences.get({ key: 'token_auth' });
      const headers        = { headers: { 'Authorization': `${token.value}` } };
      const data           = new URLSearchParams();
      data.append('id_empresa', this.evento.empresa.emp_id);
      axios.post(rutaBase+'/soporte/listarTiposEventoEmpresa', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.tiposEvento = resp.data;
          modalCarga.dismiss();
        }
      }).catch(() =>{
        console.log("ERROR");
        modalCarga.dismiss();
      });
    },

    async listarSubTiposEvento(tipoEvento, tipoHijo){
      const modalCarga  = await this.modalCargando();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data        = new URLSearchParams();
      data.append('id_tipo', tipoEvento.tev_id);
      axios.post(rutaBase+'/soporte/listarSubTiposEvento', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          const numHijos = resp.data.length;
          if(tipoHijo == 1) {
            this.subTiposEvento1 = resp.data; 
            this.subTiposEvento2 = []; 
            this.evento.tipo = this.subTipoEvento1 = this.subTipoEvento2 = '';
          }
          if(tipoHijo == 2) {
            this.subTiposEvento2 = resp.data;
            this.evento.tipo = this.subTipoEvento2 = '';
          }
          
          if(numHijos == 0) {
            this.evento.tipo = tipoEvento;
          }
          modalCarga.dismiss();
        }
      }).catch(() =>{
        modalCarga.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async registrarEvento(){
      const modalCarga = await this.modalCargando();
      await this.ajustaFotosCamara();
      this.evento.tiempoEstimado = this.tiempoEstimado;
      if(this.tipoTiempo == 'HORAS'){
        this.evento.tiempoEstimado = this.evento.tiempoEstimado*60;
      }
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('evento', JSON.stringify(this.evento));
      axios.post(rutaBase+'/soporte/registrarEvento', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          modalCarga.dismiss();
          if(resp.data.key == 1){
            this.muestraToast('REGISTRADO CORRECTAMENTE.');
            this.cerrarModal();
          }
          else{
            this.muestraToast();
          }
        }
      }).catch(() =>{
        modalCarga.dismiss();
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async modalCargando(){
      const modal = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : true,
          mode      : 'md'
        });
      await modal.present();
      return modal;
    },

    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },

    /*************************************/
    /* FUNCIONES PARA MANEJO DE IMAGENES */
    /*************************************/
    async tomarImagen(){
      const foto = await tomarFoto();
      this.imagenes.push(foto);
    },

    async subirImagen(){
      const foto = await subirFoto();
      this.imagenes.push(foto);
    },

    async resizeImg(base64) {
      const ancho = 720;
      const alto  = 1280;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const deferred = $.Deferred();
      let escala = 0;
      $("<img>").attr("src", base64).on("load", function() {
          let width, height;
          if(this.width < this.height){
            width   = ancho;
            height  = alto;
          }else{
            width   = alto;
            height  = ancho;
          }
          if(width/this.width < height/this.height){
            escala = width/this.width;
          }else{
            escala = height/this.height;
          }
          canvas.width  = this.width*escala;
          canvas.height = this.height*escala;

          context.scale(escala, escala);
          context.drawImage(this, 0, 0);
          deferred.resolve(canvas.toDataURL());
      });
      return deferred.promise();
    },

    eliminaFoto(id,indice){
      console.log(id)
      console.log(indice)
      this.idImagenBorrar = id;
      this.indiceImagenBorrar = indice;
      this.muestraAlertEliminacion();
    },

    async muestraAlertEliminacion() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Confirmar',
          message: '¿DESEA ELIMINAR LA IMAGEN SELECCIONADA?',
          buttons: [
            {
              text: 'CANCELAR',
              handler: () => {
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
            {
              text: 'ACEPTAR',
              handler: () => {
                this.imagenes.splice(this.indiceImagenBorrar, 1)
                $("#"+this.idImagenBorrar).remove();
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
          ],
        });
      return alert.present();
    },

    async ajustaFotosCamara(){
      const fotosCamara = [];
      this.imagenes.forEach( function(valor) {
        fotosCamara.push(valor.webviewPath)
      });
      for(let i=0;i<fotosCamara.length;i++){
        await this.resizeImg(fotosCamara[i]).then(img => {
          this.evento.fotos.push(img);
        });
      }
    },

  }
});
</script>

<style>
.textarea-wrapper{
  border:1px solid #c3c3c3 !important;
  border-radius: 3px !important;
}

.searchbar-input-container input {
  border-radius: 50rem!important;
  background-color: lightgrey!important;
  color: black!important;
}

</style>